import { apiConfig } from 'config';
import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';

export function cancelTwoHopAlignment(requestBody) {
  const url = apiConfig.commissionServiceCancel;
  const options = { method: 'POST', body: JSON.stringify(requestBody) };

  return fetchdata(url, options)
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
